import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StatusCompleteIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 12 12" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 10.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2.1-5.4a.4.4 0 0 0-.6-.6L5.4 6.8l-1-.9a.4.4 0 1 0-.5.6L5 7.7a.4.4 0 0 0 .6 0L8 5.1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default StatusCompleteIcon;
